<template>
  <f7-page
    class="main-farmer-detail-page"
    @page:reinit="pageReinit"
  >
    <template #fixed>
      <TheNavbar
        :nav-title="$t('common.farmer')"
        back-btn-enable
        :style="appTheme"
      >
        <template #right>
          <f7-link @click="navigateNewField">
            <img
              width="38"
              height="38"
              :src="iconAddField"
            >
          </f7-link>
          <f7-link
            icon="icon-edit"
            @click="UpdateFarmer"
          />
        </template>
      </TheNavbar>
    </template>

    <f7-block class="content-farmer-header">
      <f7-row>
        <f7-col>
          <div style="display: flex; margin-top: 10px;">
            <img
              width="70"
              height="70"
              :src="iconUser"
            >
            <div style="display: flex; flex-direction: column;  margin-left: 16px;">
              <span style="font-weight: bold;">{{ farmer.name }}</span>
              <span>{{ farmer.identifier }}</span>
            </div>
          </div>
        </f7-col>
      </f7-row>

      <div class="content-farmer-header__resume">
        <div>
          <div class="content-farmer-header__resume--title">
            Fincas
          </div>
          <div class="content-farmer-header__resume--value">
            {{ (farmer.fields) ? farmer.fields.length : "" }}
          </div>
        </div>
        <div>
          <div class="content-farmer-header__resume--title">
            Cultivos
          </div>
          <div class="content-farmer-header__resume--value">
            {{ cropsCount }}
          </div>
        </div>
        <div>
          <div class="content-farmer-header__resume--title">
            Contratos
          </div>
          <div class="content-farmer-header__resume--value">
            {{ contractsCount }}
          </div>
        </div>
      </div>
    </f7-block>
    <div
      v-if="fields != null
        && fields.length > 0"
    >
      <UCAcordeon
        :items="fields"
        class="sorted-accordion-list toggle-color-accordion-list"
        :show-badge="false"
        primary="var(--his-slate-blue)"
        font-color="#fff"
        chevron-side="left"
        :show-item-border-bottom="true"
        border-item-bottom-color="#E5EEF7"
        group-items
        group-key="name"
        :closed="true"
      >
        <template #titleOption="{ option }">
          {{ option.items[0].name }}
        </template>

        <template #after="{ item }">
          <div>
            <img
              :src="(item.items[0].contracts.length > 0) ? iconContractPending : iconContractOff"
              width="30"
              height="30"
              @click.prevent="goToContracts(item.id)"
            >
            <img
              width="30"
              height="30"
              :src="iconEditWhite"
              @click.prevent="clickEditField(item.items[0].id)"
            >
          </div>
        </template>

        <template #subOption="{ item }">
          <HiInfoRow
            title="Cultivos"
            :title-count="item.crops.length"
            style="background-color: var(--his-light-blue);"
          >
            <template #after>
              <img
                :src="iconCreateCrop"
                width="30"
                height="30"
                @click="clickNewCrop(item)"
              >
            </template>
          </HiInfoRow>
          <f7-list-item
            v-for="crop
              in
                item.crops"
            :key="crop.id"
            :title="crop.varietyName"
            :text="crop.name"
            after=" "
            class="subItem"
          >
            <template #after-start>
              <span class="padding-right-half">
                <img
                  :src="iconEdit"
                  width="30"
                  height="30"
                  @click="clickEditCrop(crop)"
                >
              </span>
            </template>
          </f7-list-item>
          <NoCropsInfo v-if="item.crops.length === 0" />
        </template>
      </UCAcordeon>
    </div>
    <NoFieldsInfo v-else />
    <FieldActionSheet
      :opened="fieldActionSheetOpened"
      :field="selectedField"
      @delete-field="loadFarmer"
      @sheet:close="fieldActionSheetOpened = false"
    />

    <CropActionSheet
      :opened="cropActionSheetOpened"
      :crop="selectedCrop"
      @sheet:close="cropActionSheetOpened = false"
    />
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import HiInfoRow from '@/components/common/HiInfoRow.vue';
import icUser from '@/static/icons/ic_user.svg';
import icEdit from '@/static/img/ic_editc.svg';
import icEditWhite from '@/static/icons/ic_edit_white.svg';
import icCreateCrop from '@/static/img/ic_create_crop.svg';
import icAddField from '@/static/img/ic_add_farm.svg';
import icContractOff from '@/static/img/ic_contract_off.svg';
import icContractPending from '@/static/img/ic_contract_pending.svg';
import FieldActionSheet from '@/components/contracts/FieldActionSheet.vue';
import CropActionSheet from '@/components/contracts/CropActionSheet.vue';
import FarmerService from '@/js/services/contracts/Farmers';
import FieldService from '@/js/services/contracts/Fields';
import NoCropsInfo from '@/components/contracts/NoCropsInfo.vue';
import NoFieldsInfo from '@/components/contracts/NoFieldsInfo.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FarmerDetailPage',
  components: {
    TheNavbar,
    FieldActionSheet,
    CropActionSheet,
    NoCropsInfo,
    NoFieldsInfo,
    UCAcordeon,
    HiInfoRow,
  },
  props: {
    farmerID: { type: String, default: '' },
  },
  data() {
    return {
      farmer: {},
      fields: [],
      selectedField: {},
      selectedCrop: {},
      cropActionSheetOpened: false,
      fieldActionSheetOpened: false,

    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    iconEdit() {
      return icEdit;
    },
    iconEditWhite: () => icEditWhite,
    iconCreateCrop() {
      return icCreateCrop;
    },
    iconUser() {
      return icUser;
    },
    iconAddField() {
      return icAddField;
    },
    iconContractOff: () => icContractOff,
    iconContractPending: () => icContractPending,
    cropsCount() {
      let cropsCount = 0;

      if (this.farmer.fields) {
        this.farmer.fields.forEach((f) => {
          cropsCount += f.crops.length;
        });
      }
      return cropsCount;
    },
    contractsCount() {
      let contractsCount = 0;

      if (this.farmer.fields) {
        this.farmer.fields.forEach((f) => {
          contractsCount += f.contracts.length;
        });
      }
      return contractsCount;
    },
  },
  watch: {
    farmerID() {
      this.loadFarmer();
    },
  },
  mounted() {
    this.loadFarmer();
  },
  methods: {
    async loadFarmer() {
      const id = Number.parseInt(this.farmerID, 10);

      const farmer = await FarmerService.getFarmersFullInfo([id]);
      if (farmer == null || farmer.length === 0) {
        f7.views.main.router.back(); return;
      }

      [this.farmer] = farmer;
      this.fields = this.processFieldList(this.farmer.fields);
    },

    processFieldList(lstFields) {
      // Sol. 275913 - Nombres de fincas que estan duplicados para el mismo agriculor,
      // se añade un indicador al final del nombre ya que el componente HiActionSortedAccordion agrupa por nombre
      const fields = [];
      let name = '';
      let num = 0;
      lstFields.forEach((f) => {
        if (f.name === name) {
          num += 1;
          f.name = `${f.name} *${num}`;
        } else {
          name = f.name;
          num = 0;
        }
        fields.push(f);
      });
      return fields;
    },
    navigateNewField() {
      f7.views.main.router.navigate('/new-field/', {
        props: {
          farmerId: Number.parseInt(this.farmerID, 10),
        },
      });
    },
    pageReinit() {
      this.loadFarmer();
    },
    clickNewCrop(field) {
      f7.views.main.router.navigate('/new-crop/', {
        props: {
          fieldId: Number.parseInt(field.id, 10),
        },
      });
    },
    clickEditCrop(crop) {
      this.selectedCrop = crop;
      this.cropActionSheetOpened = true;
    },
    UpdateFarmer() {
      f7.views.main.router.navigate('/new-farmer-wizzard/', {
        props: {
          editFarmer: true,
          farmerEdit: this.farmer,
        },
      });
    },
    async clickEditField(fieldId) {
      const field = await FieldService.getById(fieldId);
      this.selectedField = field;
      this.fieldActionSheetOpened = true;
    },
    goToContracts(id) {
      f7.views.main.router.navigate('/contracts/', {
        props: {
          fieldId: Number.parseInt(id, 10),
        },
      });
    },
  },
};
</script>

<style lang="scss">
.main-farmer-detail-page {
  .page-content {
    background: var(--his-whispering-lilac);
  }

  .main-info-row {
    background-color: var(--his-silver) !important;

    &::after {
      border-top-color: var(--his-silver) !important;
    }

    .item-title {
      color: var(--his-dark-blue);
      font-weight: 500;
    }

    .list {
      .content-checkbox {
        background: var(--his-soft-blue);

        .item-content {
          .item-inner {
            span {
              background: var(--his-oliva);
            }
          }
        }
      }
    }
  }

  .subItem {
    .item-content {
      .item-inner {
        .item-title-row {
          .item-title {
            color: var(--his-dark-blue);
          }
        }
      }
    }
  }

  .content-farmer-header {
    &__resume {
      display: flex;
      justify-content: flex-start;

      >div {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex;
        margin-top: 20px;

        &:not(:first-child) {
          padding-left: 40px;
        }
      }

      &--title {
        font-weight: 400;
        font-size: 12px;
        text-transform: uppercase;
      }

      &--value {
        color: var(--his-dark-blue);
        font-size: 18px;
        font-weight: 500;
        padding-top: 5px;
      }
    }
  }
}
</style>
